module.exports = __webpack_public_path__ + "static/media/BlockUser.3e8ff552.png";